import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { authApi } from 'api/authApi'
import coverageTypeApi from 'api/coverageTypeApi'
import coverageBenefitApi from 'api/coverageBenefitApi'
import coverageRateApi from 'api/coverageRateApi'
import planApi from 'api/planApi'
import enumsApi from 'api/enumsApi'
import insuranceProductApi from 'api/insuranceProductApi'
import vehicleDetailsSearchApi from 'api/vehicleDetailsSearchApi'
import usersApi from 'api/userApi'
import enquiryApi from 'api/enquiryApi'
import quotationApi from 'api/quotationApi'
import applicationApi from 'api/applicationApi'
import profileApi from 'api/profileApi'
import dashboardApi from 'api/dashboardApi'
import payoutApi from 'api/payoutApi'
import underwriterApi from 'api/underwriterApi'
import { auditApi } from 'api/auditApi'
import ipBlocksApi from 'api/ipBlocksApi'
import loginAttemptsApi from 'api/loginAttemptsApi'
import accountPrivacyApi from 'api/accountPrivacyApi'
import ngaoApi from 'api/ngaoApi'
import settingsApi from 'api/settingsApi'
import rootReducer, { RootState } from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      coverageTypeApi.middleware,
      profileApi.middleware,
      coverageBenefitApi.middleware,
      coverageRateApi.middleware,
      planApi.middleware,
      usersApi.middleware,
      enumsApi.middleware,
      insuranceProductApi.middleware,
      enquiryApi.middleware,
      vehicleDetailsSearchApi.middleware,
      quotationApi.middleware,
      applicationApi.middleware,
      dashboardApi.middleware,
      payoutApi.middleware,
      underwriterApi.middleware,
      auditApi.middleware,
      ipBlocksApi.middleware,
      loginAttemptsApi.middleware,
      accountPrivacyApi.middleware,
      ngaoApi.middleware,
      settingsApi.middleware
    )
})

export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>

export default store
